export default __webpack_public_path__ + "static/media/pom_base_inner.48900551.png";